import React from 'react';
import { StyleSheet, View } from 'react-native';

import { LoadingPlaceholder, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ShareLineItemLoadingPlaceholder = () => {
  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const innerContainerStyles = [styles.innerContainer, match([undefined, styles.innerContainerSM])];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <View style={innerContainerStyles}>
        <View style={styles.header}>
          <LoadingPlaceholder
            rows={1}
            rowHeight={44}
            borderRadius={theme.spacing['2']}
            palette="cream"
            style={{ width: '100%' }}
          />
        </View>

        <View style={styles.contentContainer}>
          <LoadingPlaceholder
            rows={1}
            rowHeight={420}
            borderRadius={theme.spacing['6']}
            palette="cream"
            style={{ width: '100%' }}
          />
        </View>
      </View>
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  innerContainer: {
    width: '100%',
    backgroundColor: theme.colors.APP_BACKGROUND,
    paddingVertical: theme.spacing['10'],
    alignItems: 'center',
  },
  innerContainerSM: {
    maxWidth: 380,
  },
  header: {
    width: '100%',
  },
  contentContainer: {
    width: '100%',
    alignItems: 'center',
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['10'],
  },
});
